import React from 'react';

import cl from 'classnames';

import { ACCOUNT_TYPE_ADMIN } from 'constants/index';
import { renderLogoImage } from 'detailsv2/PDFPreviewV2/Pages/TemplatePage/Header/functions';

import Logo from '../../shared/Logo';
import { renderLeftContentDefault, renderRightContentDefault } from './functions';
import s from './index.module.css';

function Header({
  logo,
  companyName,
  border = true,
  page,
  renderLeftContent = renderLeftContentDefault,
  renderRightContent = renderRightContentDefault,
  ...rest
}) {
  const logoCompanyName =
    page?.whiteLabelingOn || page.account?.type === ACCOUNT_TYPE_ADMIN
      ? page.brandSettings?.companyName
      : page.account?.companyName;

  return (
    <div className={cl({ [s.border]: border }, s.container)}>
      <div className={cl(s.flexItem, s.flexItemLeft)}>{renderLeftContent(rest)}</div>

      <div className={cl(s.flexItem, s.flexItemCenter)}>
        <Logo logo={logo} companyName={logoCompanyName} renderImage={renderLogoImage} />
      </div>

      <div className={cl(s.flexItem, s.flexItemRight)}>{renderRightContent({ ...rest, companyName })}</div>
    </div>
  );
}

export default Header;
